<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
	 <div class="mb-2">
      <el-form inline ref="form" :model="searchform">

        <el-form-item class="mb-0">
             <el-select v-model="searchform.value" :placeholder="$t('searchText.타이틀선택')" size="mini" style="width:100px;">
               <el-option
                      v-for="item in searchform.searchOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>
        

          <el-form-item class="mb-0">
             <el-input :placeholder="$t('searchText.키워드')" v-model="searchform.keyword" size="mini" style="width:120px;"></el-input>
          </el-form-item>
          <el-form-item  class="mb-0">
             <el-date-picker
                  v-model="searchform.time"
                  type="daterange"
                  range-separator="~"
                  :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:200px;">
                </el-date-picker>
          </el-form-item>
          <el-form-item class="mb-0">
            <el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button> 
          </el-form-item>
      </el-form>
       
     
    
      
        
    </div>
	<div class="d-flex align-items-center">
		
   <el-input :placeholder="$t('searchText.구글OTP')" v-model="otp" size="mini" style="width: 100px;" class="mr-2"></el-input>
<el-button type="danger" size="mini" @click="deleteAll">{{$t('searchText.선택삭제')}}</el-button>
<div class="ml-2 text-muted">{{$t('searchText.접속회원수')}}:{{cc}}</div>
	
	
	</div>

  <div class="same-ip-box mt-3">
    <div class="same-ip-title d-flex align-items-center justify-content-between">
      <div>중복 IP 로그인 목록</div>
      <div class="text-danger">총 {{sameIpList.length}}개 IP</div>
    </div>

    <el-table :data="sameIpList" v-loading="loading" border size="mini" style="width:100%;" :empty-text="$t('tableText.데이타가없습니다')">
      <el-table-column label="IP" prop="vIP" align="center" width="330">
        <template slot-scope="scope">
          <span>{{scope.row.vIP}}</span>
          <el-button v-if="!isBlocked(scope.row.vIP)" type="danger" plain size="mini" class="ml-1 ip-action-btn"
            :loading="blockingIp===scope.row.vIP" :disabled="!scope.row.vIP || blockingIp!=='' || unblockingIp!==''"
            @click="blockIp(scope.row)">IP차단</el-button>
          <el-button v-else type="primary" plain size="mini" class="ml-1 ip-action-btn"
            :loading="unblockingIp===scope.row.vIP"
            :disabled="blockingIp!=='' || unblockingIp!=='' || !blockedIps[scope.row.vIP].bidx"
            @click="unblockIp(scope.row)">IP해재</el-button>
        </template>
      </el-table-column>
      <el-table-column label="로그인 아이디" prop="mem_ids" align="left">
        <template slot-scope="scope">
          <el-tag v-for="item in getSameIpUsers(scope.row.mem_ids)" :key="scope.row.vIP+'_'+item" size="mini" class="mr-1 same-ip-user" @click="openModel(item)">{{item}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="아이디 수" prop="mem_count" align="center" width="100"></el-table-column>
    </el-table>
  </div>

  <div class="mt-3 font-weight-bold">접속 기록</div>

  <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
       border class="mt-2"
       :empty-text="$t('tableText.데이타가없습니다')" @selection-change="handleSelectionChange">
    
    <el-table-column
      type="selection"
      width="55"
      align="center">
    </el-table-column> 
     
       <el-table-column
        
        :label="$t('nav.아이디')" prop="mem_id" align="center" width="150">
         <template slot-scope="scope">
            
            <span @click="openModel(scope.row.mem_id)" class="text-primary" style="cursor:pointer">{{scope.row.mem_id}}</span>
          </template>
        
      </el-table-column> 
      <el-table-column
        :label="$t('tableText.이름')" prop="mem_name" align="center" width="150">
          <template slot-scope="scope">
            
             {{scope.row.mem_name}}({{ scope.row.memState>0 ? 'V'+scope.row.memState:level_title[scope.row.memState]}})
          </template>
      </el-table-column> 
       <el-table-column
        
        :label="$t('tableText.브라우저')" prop="vOS" align="center">
         <template slot-scope="scope">
              <el-input
            type="textarea"
            :rows="2"
            v-model="scope.row.vOS">
          </el-input>
          </template>
      </el-table-column> 

      <el-table-column label="접속기기" width="90" align="center">
        <template slot-scope="scope">
          {{ getTerminalType(scope.row.vOS) }}
        </template>
      </el-table-column>


        <el-table-column
        
        :label="$t('tableText.도메인')" prop="vReferer" align="center"  >
         <template slot-scope="scope">
              {{domain_to(scope.row.vReferer)}}
      </template>
      </el-table-column>

       

      <el-table-column :label="$t('tableText.시간')" prop="" align="center">
          <template slot-scope="scope">{{ scope.row.add_time}}</template>
        </el-table-column>
      <el-table-column
        
        :label="$t('tableText.아이피')" prop="vIP" align="center" min-width="230">
        <template slot-scope="scope">
          <span>{{scope.row.vIP}}</span>
          <el-button v-if="!isBlocked(scope.row.vIP)" type="danger" plain size="mini" class="ml-1 ip-action-btn"
            :loading="blockingIp===scope.row.vIP" :disabled="!scope.row.vIP || blockingIp!=='' || unblockingIp!==''"
            @click="blockIp(scope.row)">IP차단</el-button>
          <el-button v-else type="primary" plain size="mini" class="ml-1 ip-action-btn"
            :loading="unblockingIp===scope.row.vIP"
            :disabled="blockingIp!=='' || unblockingIp!=='' || !blockedIps[scope.row.vIP].bidx"
            @click="unblockIp(scope.row)">IP해재</el-button>
        </template>
      </el-table-column>
	
		 
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
				  <div style="flex: 1;" class="px-2">
					  <el-pagination
					  :current-page="currentPage"
					  :page-sizes="[5, 10, 15, 20]"
					  :page-size="size"
					  layout="prev, pager, next"
					  :total="total"
					  @size-change="handleSizeChange"
      				  @current-change="handleCurrentChange">
					</el-pagination>
				  </div>
				</el-footer>	
       
				
</div>
 </template>

 <script>
 import layer from '../../components/common/layer.vue';
  import layerNew from '../../components/common/layer-new.vue';
 var punycode = require('punycode');

    export default {
     components: {
      layer,layerNew
    },
    	data(){
    		return{
          otp:'',
            cc:'',
            pcode:punycode,
            level_title:{
              '-2':this.$i18n.t("msg.블랙"),
              '-1':this.$i18n.t("msg.대기"),
              '0':this.$i18n.t("msg.기본")             
            },
            
          domain:window.sessionStorage.getItem('domain'),
          sitetype:window.sessionStorage.getItem('sitetype'),
          bg:window.sessionStorage.getItem('bg'),
          userid:window.sessionStorage.getItem('userid'),
           admin_id:window.sessionStorage.getItem('admin_id'),
    		  formLoading:false,
          idDialogVisible: false,
    			
    			searchform:{
    				keyword:'',
    				time:[],
    				searchOptions:[
                
            {
              label:this.$i18n.t("msg.아이디"),
              value:'mem_id'
            },{
              label:this.$i18n.t("msg.알본"),
              value:'admin_id'
            },
            {
              label:'IP',
              value:'vip'
            },
            

            ],
		       
            
		        value:'',
          

      


    			},
    			 pickerOptions: {
    			},
           shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
        
    
      
		    		 total:0,
		    		 size:0,
		    		 loading: false,
		    		 editIndex:-1,
		    		 creatModel:false,
		    		 tableData: [],
             sameIpList: [],
		       currentPage:1,
		       multipleSelection:[],
		       blockingIp:'',
		       unblockingIp:'',
		       blockedIps:{},
    			}
    			
    			
    		},
    		created() {
    			

    			this.getList();
				this.getBlockedIps();
    			
			
		},
   
    	methods:{
        isBlocked(ip){
          return !!(ip && this.blockedIps[ip]);
        },
        getBlockedIps(){
          let token=window.sessionStorage.getItem('user');
          this.$axios({
            method:'get', url:this.domain+'/admin/blist?page=1&limit=10000',
            'Accept':'application/json', headers:{ 'Authorization':'Bearer '+token }
          }).then((response) => {
            let result=response.data && response.data.data;
            let list=result && result.data ? result.data : [];
            let blocked={};
            list.forEach((item) => { if(item.ip){ blocked[item.ip]=item; } });
            this.blockedIps=blocked;
          }).catch(() => { this.blockedIps={}; });
        },
        blockIp(row){
          let ip=row.vIP;
          if(!ip || this.blockingIp || this.unblockingIp || this.isBlocked(ip)){ return; }
          this.$confirm(ip+' IP차단 하시겠습니까?', '알림', {
            confirmButtonText:'IP차단', cancelButtonText:'취소', type:'warning'
          }).then(() => {
            let token=window.sessionStorage.getItem('user');
            this.blockingIp=ip;
            this.$axios({
              method:'post', url:this.domain+'/admin/b_insert',
              data:{ ip:ip, memo:'접속기록'+(row.mem_id ? ' - '+row.mem_id : '') },
              'Accept':'application/json', headers:{ 'Authorization':'Bearer '+token }
            }).then((response) => {
              this.$message({ message:response.data.msg, type:response.data.code==200 ? 'success' : 'warning' });
              this.blockingIp='';
              this.getBlockedIps();
            }).catch((error) => {
              this.blockingIp='';
              this.$message.error(error.response && error.response.data && error.response.data.msg ? error.response.data.msg : 'IP차단 실패했습니다.');
            });
          }).catch(() => {});
        },
        unblockIp(row){
          let ip=row.vIP;
          let blocked=this.blockedIps[ip];
          if(!blocked || !blocked.bidx || this.blockingIp || this.unblockingIp){ return; }
          this.$confirm(ip+' IP해재 하시겠습니까?', '알림', {
            confirmButtonText:'IP해재', cancelButtonText:'취소', type:'warning'
          }).then(() => {
            let token=window.sessionStorage.getItem('user');
            this.unblockingIp=ip;
            this.$axios({
              method:'post', url:this.domain+'/admin/b_up?bidx='+blocked.bidx,
              'Accept':'application/json', headers:{ 'Authorization':'Bearer '+token }
            }).then((response) => {
              this.$message({ message:response.data.msg, type:response.data.code==200 ? 'success' : 'warning' });
              this.unblockingIp='';
              this.getBlockedIps();
            }).catch((error) => {
              this.unblockingIp='';
              this.$message.error(error.response && error.response.data && error.response.data.msg ? error.response.data.msg : 'IP해재 실패했습니다.');
            });
          }).catch(() => {});
        },
        getSameIpUsers(memIds){
          if(!memIds)
          {
            return [];
          }
          return memIds.split(',').map(item=>item.trim()).filter(item=>item!='');
        },
        getTerminalType(userAgent){
          if (!userAgent) {
            return '-'
          }

          return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(userAgent)
            ? '모바일'
            : 'PC'
        },
        domain_to(v){

          var domain = v.split('/');

          console.log(domain.length);
          if(domain.length!=4)
          {
             return v;
          }
          if( domain[2] ) {
              domain = domain[2];
          } else {
              domain = ''; 
          }

          domain=punycode.toUnicode(domain);
          return domain;
        },
          handleSelectionChange(val) {
          //console.log(val)
                this.multipleSelection = val;

      },
          // 批量删除
      deleteAll(){
        this.$confirm(this.$i18n.t("msg.삭제하시겠습니까"), this.$i18n.t("msg.알림"), {
          confirmButtonText: this.$i18n.t("msg.삭제"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          type: 'warning'
        }).then(() => {
          let token=window.sessionStorage.getItem('user');

        //  console.log('hh',this.multipleSelection);

                    let newids=[];

           this.multipleSelection.forEach(item=>{
            
            //console.log('id',item.io_idx);
            newids.push(item.vNum);
           });

           //console.log('newids',newids);

          this.$axios({
                      method:'post',
                       data:{idx:newids,opt:this.otp},
                      url:this.domain+'/admin/acc_del',
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                    }else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
                    this.getList()
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          })

        
      },  
          // 关闭弹框（头部的X）
        handleClose () {
               this.idDialogVisible = false
            },
        cancelData(){
          this.idDialogVisible = false
        },
         openModel(id){
 let pix=window.screen.width;
           
                let width='1080px';
                if(pix<1200)
                {
                  width='95%';
                }
          if(this.admin_id=='soft10')
           {
                this.$layer.iframe({
                type: 2,
                title: id,
                content: {
                    content: layerNew,
                    parent: this,
                    data:{
                    info:{id:id},
                    layerid:'id'
                    }
                  
                },
                shadeClose: false,
                maxmin:true,
                shade: false,
                  area: [width+'', '700px'],
             
             });
              return;
           }
 let layerwidth='950px';
                if(pix<1200)
                {
                  layerwidth='95%';
                }
           this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layer,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: [layerwidth+'', '680px'],
         
        });
        },
    			 // 搜索事件
			searchEvent(){

                if(this.searchform.keyword!='' && this.searchform.value == ''){
                	  this.$message(this.$i18n.t("msg.검색타이틀선택하세요"));
                	 return;
                }

              
            this.currentPage=1;


    			this.getList();
    			
             

    		},
    		 handleSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.size = val
			        this.getList();
			        this.loading= true

			      },
			      handleCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.currentPage = val
			        this.getList();
			        this.loading= true
			      },
			    
       
    		getList(){

    		  
             

               let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

              
    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');
    				//console.log(token);
    			 let urls=this.domain+'/admin/acclist?s_time='+s_time+'&e_time='+e_time+'&'+this.searchform.value+'='+this.searchform.keyword+'&page='+this.currentPage;

    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                    // console.log('data=',response.data.data.data)
                     let data = response.data.data
                     this.tableData =data.data
                     this.total = data.total
                     this.currentPage = data.current_page
                     this.size =data.per_page
                     this.cc = response.data.cc
                     this.sameIpList = response.data.same_ip_list ? response.data.same_ip_list : []
                     
                     this.loading =false
               
            }).catch((error) =>{
            	

              this.$message.error(error);
              this.loading = false
                //console.log('error',error.response)       //请求失败返回的数据
               
            })
    		},
    		
    		
    	
    		
    	}
  }
</script>

 <style scoped>
/deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }
 /deep/ .el-dialog{
    height:700px;overflow-y:scroll
 }
 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
 /deep/ .el-dialog__body{
  padding:10px 20px
 }

 .same-ip-box{
  border:1px solid #f1b0b7;
  background:#fff;
 }
 .same-ip-title{
  padding:8px 12px;
  font-size:14px;
  font-weight:bold;
  background:#fff5f5;
  border-bottom:1px solid #f1b0b7;
 }
 .same-ip-user{
  cursor:pointer;
  margin-top:2px;
  margin-bottom:2px;
 }
 .ip-action-btn{
  padding:4px 6px;
  font-size:11px;
 }


</style>



// WEBPACK FOOTER //
// src/views/acclist/list.vue